import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import {
  Box,
  Heading,
  Text,
  Image,
  SimpleGrid,
  VStack,
  HStack,
  IconButton,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Icon,
  useBreakpointValue,
  // Grid,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Center,
  Spinner,
  Flex,
  Badge,
  useColorModeValue,
  Container,
  // AspectRatio,
  // Divider,
  // Stack,
  Collapse,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { AddIcon, MinusIcon } from "@chakra-ui/icons";
import { useParams, useNavigate, Link } from "react-router-dom";
import {
  FiCheckCircle,
  FiZoomIn,
  // FiArrowRight,
  FiStar,
  // FiArrowLeft,
  FiChevronRight,
  FiChevronLeft,
} from "react-icons/fi";
import { useTranslation } from "react-i18next";
// import { products } from "./ProductDetails";
// import galleryImages1 from "../../../assets/images/glass1.jpg";
// import galleryImages2 from "../../../assets/images/glass4.jpg";
// import galleryImages3 from "../../../assets/images/glass3.jpg";
// import galleryImages4 from "../../../assets/images/glass2.jpg";
// import glass1 from "../../../assets/images/glass1.jpg";
// import glass2 from "../../../assets/images/glass2.jpg";
// import glass3 from "../../../assets/images/glass3.jpg";
// import glass4 from "../../../assets/images/glass4.jpg";
// import glass5 from "../../../assets/images/glass5.jpg";
// import glass6 from "../../../assets/images/glass6.jpg";
import Header from "../header/Header";
import { useHomeHook } from "../home/useHomeHook";
import Footer from "../footer/Footer";
import * as Constants from "../../../constants/Constants";

const MotionBox = motion(Box);
// const MotionHeading = motion(Heading);
const MotionImage = motion(Image);
const MotionButton = motion(Button);

const Product = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedImage, setSelectedImage] = useState(null);
  const { id } = useParams();
  const productId = parseInt(id);
  const [images, setImages] = useState([]);
  useEffect(() => {
    axios
      .get(Constants.REACT_APP_API_URL + "api/upload/product")
      .then((res) => {
        if (res.data.success) {
          setImages(res.data.data);
        }
      })
      .catch((err) => console.log(err));
  }, []);
  console.log(images)
  const products = [
    {
      id: 1,
      src: images[0]?.image_url,
      alt: "Sliding Partitions",
      title: "Sliding Partitions",
      shortDescription: "Discover our exquisite range of luxury glass products.",
      features: ["Innovative", "Modern", "Durable", "Elegant", "Customizable"],
    },
    {
      id: 2,
      src: images[1]?.image_url,
      alt: "Swing Partitions",
      title: "Swing Partitions",
      shortDescription: "Explore our collection of modern door designs.",
      features: ["Stylish", "Functional", "Space-Saving", "Premium"],
    },
    // {
    //   id: 3,
    //   src: glass3,
    //   alt: "Flush Doors",
    //   title: "Flush Doors",
    //   shortDescription: "Stylish and functional wardrobe solutions.",
    //   relatedImages: [glass6, door, studioglassdoors],
    // },
    {
      id: 4,
      src: images[8]?.image_url,
      alt: "Bathroom & Wardrobes",
      title: "Bathroom & Wardrobes",
      shortDescription: "State-of-the-art shower enclosures for every bathroom.",
      features: ["Minimalist", "Elegant Finish", "Versatile"],
    },
    {
      id: 5,
      src: images[10]?.image_url,
      alt: "Shower Enclosures",
      title: "Shower Enclosures",
      shortDescription: "Modern and elegant kitchen collections.",
      features: ["Sleek", "Sturdy", "Smooth Operation"],
    },
    {
      id: 6,
      src: images[9]?.image_url,
      alt: "Led Mirrors",
      title: "Led Mirrors",
      shortDescription: "Stylish and functional wardrobe solutions.",
      features: ["Innovative", "Contemporary Design", "Energy-Efficient"],
    },
  ];
  const productDetails = products.find((p) => p.id === productId);
  const [isLoading, setIsLoading] = useState(true);
  // const [zoomLevel, setZoomLevel] = useState(1);
  const galleryRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const [openIndex, setOpenIndex] = useState(null);
  const [magnifier, setMagnifier] = useState({ show: false, x: 0, y: 0, bgX: 0, bgY: 0 });

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const handleScroll = () => {
    if (galleryRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = galleryRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth);
    }
  };

  const scroll = (direction) => {
    if (galleryRef.current) {
      galleryRef.current.scrollBy({
        left: direction === "left" ? -300 : 300,
        behavior: "smooth",
      });
    }
  };
  const [handleMenuEnter, handleMenuLeave, menuVisible, setHoveredItem] =
    useHomeHook(props);

  // Color mode values
  const bgColor = useColorModeValue("white", "#FFFFFF");
  const cardBg = useColorModeValue("#FFFFFF", "#FFFFFF");
  const textColor = useColorModeValue("#000000", "#000000");
  // const accentColor = useColorModeValue("#87CEEB", "#87CEEB");
  const borderColor = useColorModeValue("#FFFFFF", "#FFFFFF");

  const handleImageClick = (image) => {
    setSelectedImage(image);
    onOpen();
  };

  const breadcrumbs = [
    { label: t("home"), path: "/" },
    { label: productDetails?.title || "", path: "#" },
  ];

  const features = [
    t("high quality materials"),
    t("modern designs"),
    t("safety and security"),
    t("customizable options"),
    t("energy efficient"),
    t("easy maintenance"),
  ];

  const specifications = {
    Dimensions: "1200mm x 800mm x 2500mm",
    Materials: "Tempered Glass, Stainless Steel",
    Warranty: "5 years Limited",
    Customization: "Multiple finishes available",
    Installation: "Professional service included",
    "Lead Time": "2-4 weeks",
  };

  const testimonials = [
    {
      quote:
        "I can't say enough good things about Universal Glass From start to finish, their service is absolutely extraordinary. The team is incredibly professional, attentive to detail, and goes above and beyond to ensure everything is perfect.",
      author: "sPLAYce studio",
      rating: 5,
    },
    {
      quote:
        "We really appreciate Mr Abhishek for helping us with super fast installation without compromising quality. The team is very committed and professional to their work. Highly recommended!",
      author: "Suruchi Rathi",
      rating: 5,
    },
    {
      quote:
        "Excellent products and professional service Smooth experience from start to finish I Highly recommended good to go.",
      author: "Webcrux Technology",
      rating: 5,
    },
  ];

  const faq = [
    {
      question: "What makes Enso's products unique?",
      answer:
        "We combine premium materials with innovative designs for durable, beautiful solutions.",
    },
    {
      question: "How can I place an order?",
      answer:
        "Order through our website or contact our customer support team for assistance.",
    },
    {
      question: "What's the warranty coverage?",
      answer:
        "5-year warranty covering defects in materials and craftsmanship.",
    },
    {
      question: "Do you offer installation services?",
      answer:
        "Yes, we provide professional installation by certified technicians.",
    },
  ];

  const gridColumns = useBreakpointValue({ base: 1, md: 2, lg: 3 });
  const isMobile = useBreakpointValue({ base: true, md: false });

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const yOffset = isMobile ? -180 : -130; // or calculate your header height
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
    const defaultBg = useColorModeValue("#FFFFFF", "#FFFFFF");

  return (
    <Box bg={useColorModeValue("#FFFFFF", "#FFFFFF")}>
      <Header
        handleMenuEnter={handleMenuEnter}
        handleMenuLeave={handleMenuLeave}
        menuVisible={menuVisible}
        setHoveredItem={setHoveredItem}
        collections={[
          { name: "Sliding Partitions", path: "/product/1" },
          { name: "Swing Partitions", path: "/product/2" },
          // { name: "Flush Doors", path: "/product/3" },
          { name: "Bathroom & Wardrobes", path: "/product/4" },
          { name: "Shower Enclosures", path: "/product/5" },
          { name: "Led Mirrors", path: "/product/6" },
        ]}
      />
      {/* Navigation */}
      <Box
        // bg={bgColor}
        bg={scrolled ? "#ffffff" : defaultBg}
        // borderBottomWidth="1px"
        borderColor={borderColor}
        position="sticky"
        top="65px"
        zIndex={10}
        boxShadow="sm"
      >
        <Container maxW="container.xl" px={{ base: 4, md: 8 }}>
          <Flex
            direction={{ base: "column", md: "row" }}
            align={{ base: "flex-start", md: "center" }}
            justify="space-between"
            py={3}
          >
            <Heading
              size="lg"
              mb={{ base: 2, md: 0 }}
              px={{ base: 2, md: 0 }}
            >
              {productDetails?.title}
              <Breadcrumb mt={2} mb={6} separator={<FiChevronRight color="#FFFFFF" />} fontSize="sm">
          {breadcrumbs.map((crumb, index) => (
            <BreadcrumbItem key={index}>
              <BreadcrumbLink
                as={Link}
                to={crumb.path}
                color={
                  index === breadcrumbs.length - 1 ? "black" : "black"
                }
                fontWeight={
                  index === breadcrumbs.length - 1 ? "normal" : "medium"
                } size="sm"
              >
                {crumb.label}
              </BreadcrumbLink>
            </BreadcrumbItem>
          ))}
        </Breadcrumb>
            </Heading>

            {/* Navigation */}
            <Box
              width={{ base: "100%", md: "auto" }}
              overflowX="auto"
              sx={{
                "&::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              <Flex gap={2} py={1} px={{ base: 2, md: 0 }}>
                {["Features", "Gallery", "Specs", "Reviews", "FAQ"].map(
                  (section) => (
                    <Button
                      key={section}
                      variant="ghost"
                      color="black"
                      _hover={{
                        bg: "#87CEEB",
                        transform: "translateY(-2px)",
                      }}
                      _active={{ bg: "#87CEEB" }}
                      // onClick={() =>
                      //   document
                      //     .getElementById(section.toLowerCase())
                      //     ?.scrollIntoView({ behavior: "smooth", block: "center" })
                      // }
                      onClick={() => scrollToSection(section.toLowerCase())}
                      fontSize="sm"
                      fontWeight="medium"
                      whiteSpace="nowrap"
                      px={4}
                      transition="all 0.2s"
                    >
                      {section}
                    </Button>
                  )
                )}
              </Flex>
            </Box>
          </Flex>
        </Container>
      </Box>

      {/* Hero Section */}
      <Container maxW="container.xl" px={{ base: 4, md: 8 }} py={12} mt={12}>
        

        <Flex
          direction={{ base: "column", md: "row" }}
          gap={8}
          align="center"
          mb={{ md: 12 }}
        >
          <Box flex={1} mb={{ base: 2 }}>
            <Badge
              // colorScheme="blue"
              px={4}
              py={1}
              borderRadius="full"
              fontSize="sm"
              mb={4}
            >
              PREMIUM PRODUCT
            </Badge>
            <Heading
              size="2xl"
              mb={4}
              color="black"
              // bgGradient="linear(to-r, #87CEEB, #800080)"
              // bgClip="text"
            >
              {productDetails?.title}
            </Heading>
            <Text fontSize="lg" color={textColor} mb={6}>
              {productDetails?.shortDescription}
            </Text>
            {/* <Button
              // colorScheme="blue"
              size="lg"
              rightIcon={<FiArrowRight />}
              onClick={() => navigate("/contact")}
            >
              Get a Quote
            </Button> */}
            <Button
              as="button"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              px={8}
              py={4}
              bg="white"
              color="black"
              fontWeight="bold"
              boxShadow="lg"
              fontSize="lg"
              onClick={() => navigate("/contact")}
              _hover={{ bg: "white", color: "black" }}
            >
              Get a Quote
            </Button>
          </Box>

          {/* <Box flex={1} position="relative">
            {isMobile ? (
              <Image
                src={productDetails?.src}
                alt={productDetails?.alt}
                objectFit="cover"
                borderRadius="xl"
                boxShadow="xl"
                onLoad={() => setIsLoading(false)}
              />
            ) : (
              <Box
                style={{
                  transform: `scale(${zoomLevel})`,
                  transition: "transform 0.2s ease-in-out",
                }}
              >
                <AspectRatio ratio={3 / 2} w="100%">
                  <Image
                    src={productDetails?.src}
                    alt={productDetails?.alt}
                    objectFit="cover"
                    borderRadius="xl"
                    boxShadow="xl"
                    onLoad={() => setIsLoading(false)}
                  />
                </AspectRatio>
                <IconButton
                  aria-label="Zoom image"
                  icon={<FiZoomIn />}
                  position="absolute"
                  bottom={zoomLevel === 1 ? 4 : "1rem"}
                  right={zoomLevel === 1 ? 4 : "1rem"}
                  // colorScheme="blackAlpha"
                  bg="white"
                  color="black"
                  _hover={{bg:"white", color:"black"}}
                  borderRadius="full"
                  onClick={() => setZoomLevel((prev) => (prev === 1 ? 1.3 : 1))}
                />
              </Box>
            )}
            {isLoading && (
              <Center
                position="absolute"
                top={0}
                left={0}
                w="100%"
                h="100%"
                bg="blackAlpha.100"
                borderRadius="xl"
              >
                <Spinner size="xl" color="#87CEEB" />
              </Center>
            )}
          </Box> */}
          <Box flex={1} position="relative">
            {isMobile ? (
              // Mobile → Normal Image
              <Image
                src={productDetails?.src}
                alt={productDetails?.alt}
                objectFit="cover"
                borderRadius="xl"
                boxShadow="xl"
                onLoad={() => setIsLoading(false)}
              />
            ) : (
              // Desktop → Magnifier Image
              <Box position="relative" cursor="none"
                onMouseMove={(e) => {
                  const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
                  const x = e.clientX - left;
                  const y = e.clientY - top;
                  setMagnifier({ show: true, x, y, bgX: (x / width) * 100, bgY: (y / height) * 100 });
                }}
                onMouseLeave={() => setMagnifier((prev) => ({ ...prev, show: false }))}
              >
                <Image
                  src={productDetails?.src}
                  alt={productDetails?.alt}
                  objectFit="cover"
                  borderRadius="xl"
                  boxShadow="xl"
                  w="100%"
                  onLoad={() => setIsLoading(false)}
                />
                {magnifier.show && (
                    <Box
                      position="absolute"
                      pointerEvents="none"
                      w="120px"
                      h="120px"
                      borderRadius="full"
                      border="2px solid white"
                      boxShadow="0 0 10px rgba(0,0,0,0.3)"
                      zIndex={20} 
                      top={magnifier.y - 50 + "px"}
                      left={magnifier.x - 50 + "px"}
                      backgroundImage={`url(${productDetails?.src})`}
                      backgroundRepeat="no-repeat"
                      backgroundSize="450% 450%" // Zoom Level
                      backgroundPosition={`${magnifier.bgX}% ${magnifier.bgY}%`}
                    />
                )}
              </Box>
            )}
            {isLoading && (
              <Center
                position="absolute"
                top={0}
                left={0}
                w="100%"
                h="100%"
                bg="blackAlpha.100"
                borderRadius="xl"
              >
                <Spinner size="xl" color="#87CEEB" />
              </Center>
            )}
          </Box>
        </Flex>
      </Container>

      <Container maxW="container.xl" px={{ base: 4, md: 8 }} >
        {/* Features Section */}
        <Box id="features">
          <VStack spacing={6} mb={8}>
            <Badge
              // colorScheme="blue"
              px={4}
              py={1}
              borderRadius="full"
              fontSize="sm"
            >
              WHY CHOOSE THIS
            </Badge>
            <Heading size="xl" textAlign="center">
              Premium Features
            </Heading>
            {/* <Divider w="100px" borderWidth="2px" borderColor="#87CEEB" /> */}
          </VStack>

          <SimpleGrid columns={gridColumns} spacing={6}>
            {features.map((feature, index) => (
              <MotionBox
                key={index}
                whileHover={{ y: -5 }}
                transition={{ duration: 0.2 }}
              >
                <HStack
                  spacing={4}
                  align="flex-start"
                  p={6}
                  bg={bgColor}
                  borderRadius="xl"
                  boxShadow="md"
                  borderWidth="1px"
                  borderColor={borderColor}
                  h="100%"
                >
                  <Icon as={FiCheckCircle} w={6} h={6} color="#87CEEB" />
                  <Text fontSize="lg" color={textColor}>
                    {feature}
                  </Text>
                </HStack>
              </MotionBox>
            ))}
          </SimpleGrid>
        </Box>

        {/* Gallery Section */}
        <Box id="gallery" py={12}>
          <VStack spacing={6} mb={8}>
            <Badge
              // colorScheme="blue"
              px={4}
              py={1}
              borderRadius="full"
              fontSize="sm"
            >
              VISUAL SHOWCASE
            </Badge>
            <Heading size="xl" textAlign="center">
              Product Gallery
            </Heading>
            {/* <Divider w="100px" borderWidth="2px" borderColor="#87CEEB" /> */}
          </VStack>

          {/* <Box mb={8}>
            <AspectRatio ratio={16/9}>
              <Image
                src={selectedImage || galleryImages3}
                alt="Featured Image"
                objectFit="cover"
                borderRadius="xl"
              />
            </AspectRatio>
          </Box> */}

          <Box position="relative" mt={8}>
            {/* Left Arrow - Conditionally shown */}
            {showLeftArrow && (
              <IconButton
                aria-label="Scroll left"
                icon={<Icon as={FiChevronLeft} />}
                position="absolute"
                left={-14}
                top="50%"
                transform="translateY(-50%)"
                onClick={() => scroll("left")}
                colorScheme="blue"
                variant="posoutline"
                borderRadius="full"
                zIndex={1}
                display={{ base: "none", md: "flex" }}
                boxShadow="md"
                _hover={{ transform: "translateY(-50%) scale(1.1)" }}
                transition="all 0.2s"
              />
            )}

            {/* Gallery Container */}
            <Flex
              ref={galleryRef}
              gap={4}
              overflowX="auto"
              py={4}
              px={2}
              onScroll={handleScroll}
              sx={{
                "&::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              {[
                images[0]?.image_url,
                images[8]?.image_url,
                images[2]?.image_url,
                images[1]?.image_url,
              ].map((img, index) => (
                <MotionBox
                  key={index}
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.2 }}
                  onClick={() => handleImageClick(img)}
                  position="relative"
                  minW={{ base: "200px", md: "300px" }}
                  h={{ base: "150px", md: "200px" }}
                  borderRadius="xl"
                  overflow="hidden"
                  boxShadow="lg"
                  borderWidth="2px"
                  borderColor={
                    selectedImage === img ? "#87CEEB" : "transparent"
                  }
                  flexShrink={0}
                >
                  <Image
                    src={img}
                    alt={`Gallery ${index + 1}`}
                    objectFit="cover"
                    w="100%"
                    h="100%"
                  />
                  <Box
                    position="absolute"
                    top={0}
                    left={0}
                    right={0}
                    bottom={0}
                    bg="blackAlpha.600"
                    opacity={0}
                    transition="all 0.3s"
                    _hover={{ opacity: 1 }}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <VStack spacing={2}>
                      <Icon as={FiZoomIn} color="white" w={6} h={6} />
                      <Text color="white" fontSize="sm" fontWeight="bold">
                        Tap to Open
                      </Text>
                    </VStack>
                  </Box>
                </MotionBox>
              ))}
            </Flex>

            {/* Right Arrow - Conditionally shown */}
            {showRightArrow && (
              <IconButton
                aria-label="Scroll right"
                icon={<Icon as={FiChevronRight} />}
                position="absolute"
                right={-14}
                top="50%"
                transform="translateY(-50%)"
                onClick={() => scroll("right")}
                colorScheme="blue"
                variant="posoutline"
                borderRadius="full"
                zIndex={1}
                display={{ base: "none", md: "flex" }}
                boxShadow="md"
                _hover={{ transform: "translateY(-50%) scale(1.1)" }}
                transition="all 0.2s"
              />
            )}

            {/* Mobile Scroll Indicator */}
            <Box
              display={{ md: "none" }}
              textAlign="center"
              mt={2}
              color="#FFFFFF"
              fontSize="sm"
            >
              <Text>Swipe to view more</Text>
            </Box>
          </Box>
        </Box>

        {/* Specifications Section */}
        <Box id="specs" bg={cardBg} borderRadius="xl" px={8}>
          <VStack spacing={6} mb={8}>
            <Badge
              // colorScheme="blue"
              px={4}
              py={1}
              borderRadius="full"
              fontSize="sm"
            >
              TECHNICAL DETAILS
            </Badge>
            <Heading size="xl" textAlign="center">
              Specifications
            </Heading>
            {/* <Divider w="100px" borderWidth="2px" borderColor="#87CEEB" /> */}
          </VStack>

          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
            {Object.entries(specifications).map(([key, value], index) => (
              <Box
                key={index}
                p={6}
                borderRadius="xl"
                bg={bgColor}
                boxShadow="sm"
                borderWidth="1px"
                borderColor={borderColor}
              >
                <Text fontWeight="bold" mb={2} color="#000000" fontSize="lg">
                  {key}
                </Text>
                <Text fontSize="md" color={textColor}>
                  {value}
                </Text>
              </Box>
            ))}
          </SimpleGrid>
        </Box>

        {/* Testimonials Section */}
        <Box id="reviews" py={12}>
          <VStack spacing={6} mb={8}>
            <Badge
              // colorScheme="blue"
              px={4}
              py={1}
              borderRadius="full"
              fontSize="sm"
            >
              CUSTOMER FEEDBACK
            </Badge>
            <Heading size="xl" textAlign="center">
              What Our Clients Say
            </Heading>
            {/* <Divider w="100px" borderWidth="2px" borderColor="#87CEEB" /> */}
          </VStack>

          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8}>
            {testimonials.map(({ quote, author, rating }, index) => (
              <MotionBox
                key={index}
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.2 }}
              >
                <VStack
                  p={6}
                  boxShadow="lg"
                  borderRadius="xl"
                  spacing={4}
                  bg="white"
                  height="100%"
                  justify="space-between"
                >
                  <Box position="relative" w="100%">
                    <Text
                      fontSize="3xl"
                      position="absolute"
                      top="-20px"
                      left="-10px"
                      color="#87CEEB"
                      fontFamily="serif"
                    >
                      "
                    </Text>
                    <Text
                      fontSize="md"
                      fontStyle="italic"
                      color="#000000"
                      px={4}
                    >
                      {quote}
                    </Text>
                    {/* <Text
                      fontSize="3xl"
                      position="absolute"
                      bottom="-40px"
                      right="-10px"
                      color="#87CEEB"
                      fontFamily="serif"
                    >
                      "
                    </Text> */}
                  </Box>
                  <HStack justify="flex-start" w="100%" spacing={3} mt={4}>
                    <Box
                      bg="black"
                      opacity={0.5}
                      p={2}
                      borderRadius="full"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      color="white"
                      fontWeight="bold"
                    >
                      {author.charAt(0)}
                    </Box>
                    <VStack align="start" spacing={0}>
                      <Text fontWeight="bold" color="black">
                        {author}
                      </Text>
                      <Text fontSize="sm" color="#FFFFFF">
                        {t("Customer")}
                      </Text>
                    </VStack>
                    <HStack spacing={1}>
                      {[1, 2, 3, 4, 5].map((star) => (
                        <Icon
                          key={star}
                          as={FiStar}
                          color={star <= rating ? "#F6E05E" : "#F6E05E"}
                          fill={star <= rating ? "#F6E05E" : "none"}
                          w={5}
                          h={5}
                        />
                      ))}
                      <Badge colorScheme="yellow">{rating}/5 ★</Badge>
                    </HStack>
                  </HStack>
                </VStack>
              </MotionBox>
            ))}
          </SimpleGrid>
          {/*<Box
            mt={12}
            p={6}
            bg="white"
            borderRadius="xl"
            boxShadow="md"
            maxW="2xl"
            mx="auto"
          >
            <HStack justify="space-between" align="center">
              <VStack align="start">
                <Heading size="md" color="#87CEEB">
                  {t("Overall Rating")}
                </Heading>
                <Text fontSize="sm" color="#FFFFFF">
                  {t("Based on")} {testimonials.length} {t("reviews")}
                </Text>
              </VStack>
              <HStack spacing={4}>
                <Heading size="3xl" color="#87CEEB">
                  {(
                    testimonials.reduce((acc, curr) => acc + curr.rating, 0) /
                    testimonials.length
                  ).toFixed(1)}
                </Heading>
                <VStack spacing={0} align="start">
                  <HStack spacing={1}>
                    {[1, 2, 3, 4, 5].map((star) => (
                      <Icon
                        key={star}
                        as={FiStar}
                        color="#F6E05E"
                        fill="#F6E05E"
                        w={4}
                        h={4}
                      />
                    ))}
                  </HStack>
                  <Text fontSize="sm" color="#FFFFFF">
                    {t("out of")} 5
                  </Text>
                </VStack>
              </HStack>
            </HStack>
          </Box>*/}
        </Box>
        {/* FAQ Section */}
        <Box id="faq" >
          <VStack spacing={6} mb={8}>
            <Badge
              // colorScheme="blue"
              px={4}
              py={1}
              borderRadius="full"
              fontSize="sm"
            >
              NEED HELP?
            </Badge>
            <Heading size="xl" textAlign="center">
              Frequently Asked Questions
            </Heading>
            {/* <Divider w="100px" borderWidth="2px" borderColor="#87CEEB" /> */}
          </VStack>

          <VStack spacing={6} align="stretch">
            {faq.map(({ question, answer }, index) => {
              const isOpen = openIndex === index;

              return (
                <MotionBox
                  key={index}
                  whileHover={{ scale: 1.01 }}
                  transition={{ duration: 0.2 }}
                  w="100%"
                >
                  <Box
                    p={6}
                    borderRadius="xl"
                    bg="white"
                    boxShadow="md"
                    borderWidth="1px"
                    borderColor="#FFFFFF"
                    cursor="pointer"
                    onClick={() => toggleFAQ(index)}
                  >
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Text fontWeight="bold" fontSize="lg" color="#000000">
                        {question}
                      </Text>
                      <IconButton
                        icon={isOpen ? <MinusIcon /> : <AddIcon />}
                        variant="ghost"
                        colorScheme="green"
                        size="sm"
                        aria-label="Toggle FAQ"
                      />
                    </Box>

                    <Collapse in={isOpen} animateOpacity>
                      <Text mt={3} color="#000000">
                        {answer}
                      </Text>
                    </Collapse>
                  </Box>
                </MotionBox>
              );
            })}
          </VStack>
        </Box>

        {/* CTA Section */}
        <Box py={12} textAlign="center">
          <VStack
            spacing={6}
            // bgGradient="linear(to-r, #87CEEB, #800080)"
            p={12}
            borderRadius="xl"
          >
            <Heading size="xl" color="black">
              Ready to Transform Your Space?
            </Heading>
            <Text fontSize="xl" color="black.100" maxW="2xl">
              Contact us today for a free consultation and quote
            </Text>
            <MotionButton
              as="button"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              px={8}
              py={4}
              bg="black" 
              opacity={0.7}
              color={"white"}
              _hover={{ bg: "white", color: "black" }}
              fontWeight="bold"
              borderRadius="full"
              boxShadow="lg"
              fontSize="lg"
              onClick={() => navigate("/contact")}
            >
              Get Started
            </MotionButton>
          </VStack>
        </Box>
      </Container>

      {/* Image Modal */}
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
        <ModalOverlay bg="blackAlpha.800" />
        <ModalContent bg="transparent" boxShadow="none" mx={{ base: 4, md: 0 }}>
          <ModalCloseButton
            color="white"
            bg="blackAlpha.600"
            _hover={{ bg: "blackAlpha.700" }}
            size={{base:"sm",md:"lg"}}
            top={{ base: "1rem", md: "1.5rem" }}
            right={{ base: "1rem", md: "1.5rem" }}
          />
          <ModalBody p={0} display="flex" justifyContent="center">
            <MotionImage
              src={selectedImage}
              alt="Enlarged view"
              w="100%"
              h="auto"
              objectFit="contain"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3 }}
              borderRadius="xl"
            />
          </ModalBody>
        </ModalContent>
      </Modal>
      <Footer />
    </Box>
  );
};

export default Product;
